module.exports = __webpack_public_path__ + "media/images/countryrect/vn-45b1232d9a2590f656d17de91dbd33c5.svg";